import React from 'react';
import CTASection from '../components/CTASection';
import ExportProcess from '../components/ExportProcess';

const ProcessPage = () => {
  return (
    <main>
      <ExportProcess />
      <CTASection
        eyebrow="Process confidence"
        title="Need product, packing, and dispatch details for your market?"
        text="The process is easiest to plan when the buyer shares destination, quantity, product format, and expected shipping timeline at the start."
        primaryLabel="Send Process Inquiry"
        secondaryLabel="View Quality Standards"
        secondaryPath="/quality"
      />
    </main>
  );
};

export default ProcessPage;
